import { IFilterSet, TAllFilter } from 'shared/types/filters';
import { isAvailableStrict, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';

const OFFER_TYPE = FOfferType.FlatOld;

export const FLAT_OLD_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'roomType',
      'price',
      'withNeighbors',
      'undergroundTime',
      'squareMeterArea',
      'floor',
      'floors',
      'subsidizedMortgage',

      /**
       * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
       */
      'blackFridayEtazhi',
      'repair',
      'constructionYear',
      'constructionType',
      'demolition',
      'balcony',
      'elevators',
      'kitchenStove',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'windows',
      'apartments',
      'parking',
      'offerSeller',
      'saleType',
      'flatShare',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailableStrict(FDealType.RentLongterm, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'roomType',
      'price',
      'earlyAccess',
      'withNeighbors',
      'isOwner',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'layout',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'windows',
      'floor',
      'floors',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
